<ng-container *ngIf="auth.user$ | async as user">
  <nav
    class="position-sticky d-flex align-items-center justify-content-between p-3 text-dark h-16 border-bottom top-0 z-3 bg-white"
  >
    <button *ngIf="isMobileView" (click)="isSidenavOpened = !isSidenavOpened"class="bg-transparent border-0 h-100 me-2">
      <mat-icon>menu</mat-icon>
    </button>
    <div class="d-flex align-items-center gap-4">
      <a [routerLink]="['']">
        <img
          class="header-logo"
          src="assets/fixation-logo.svg"
          alt="Fixation logo"
        />
      </a>
      <ng-container *ngIf="!isMobileView">
        <ng-container *ngFor="let route of availableRoutes">
          <a
            class="text-decoration-none"
            [routerLink]="route.path"
            #link="routerLinkActive"
            routerLinkActive="fw-bold text-dark"
            [class.fw-bold]="link.isActive"
            [class.text-dark]="link.isActive"
            [class.text-muted]="!link.isActive"
          >
            {{ route.label }}
          </a>
        </ng-container>
      </ng-container>
    </div>
    <app-auth-menu [name]="user.name" [email]="user.username"></app-auth-menu>
  </nav>
</ng-container>

<!-- Render the side nav only for small and medium screens -->
<ng-container *ngIf="isMobileView">
  <mat-drawer-container class="sidenav-container" autosize>
    <mat-drawer #drawer class="sidenav" [(opened)]="isSidenavOpened">
      <mat-nav-list>
        <a
          *ngFor="let route of availableRoutes"
          mat-list-item
          [routerLink]="route.path"
          routerLinkActive="active-tab"
          (click)="isSidenavOpened = false">
          {{ route.label }}
        </a>
      </mat-nav-list>
    </mat-drawer>

    <mat-drawer-content class="bg-white">
      <div class="sidenav-content p-3">
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</ng-container>



<div *ngIf="!isMobileView">
  <main class="p-3">
    <router-outlet></router-outlet>
  </main>
</div>
